function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "6.749",
  cy: "6.749",
  r: ".75"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "6.749",
  cy: "9.751",
  r: ".75"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.25 6h-4.5a.75.75 0 100 1.5h4.5a.75.75 0 000-1.5zM15 9.75a.75.75 0 00-.75-.75h-4.5a.75.75 0 000 1.5h4.5a.75.75 0 00.75-.75zm-6 3a.752.752 0 00.75.75h.33a5.096 5.096 0 01.81-1.5H9.75a.752.752 0 00-.75.75z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "6.749",
  cy: "12.75",
  r: ".75"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "6.749",
  cy: "15.749",
  r: ".75"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M18.771 17.71l2.008 2.009a.75.75 0 01-1.06 1.06l-2.008-2.008a4.13 4.13 0 111.06-1.06zm-4.401-4.76a2.625 2.625 0 102.009 4.85 2.625 2.625 0 00-2.01-4.85z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.41 18H4.5V4.5h12v5.362c.525.105 1.031.29 1.5.548V4.5A1.504 1.504 0 0016.5 3h-12A1.504 1.504 0 003 4.5V18a1.504 1.504 0 001.5 1.5h7.065A5.15 5.15 0 0110.41 18z"
}));